(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-image"] && !Shopify.designMode) return;
  try {
    
function maxVal(val, itsmax) {
    if (val <= itsmax && val >= 0) return val
    else if (val <0) return 0
    else return itsmax;
}

jQuery(".img-comp-overlay").each(function () {
    var slider = jQuery(this).parents(".img-comp-container").find(".img-comp-slider");
    var img = jQuery(this).find("img");

    var slidef = function () {
        var e = window.event;
        var x = img.offset().left;
        img.parent().width(maxVal(e.pageX - x, jQuery(".img-comp-img").width()));
        slider.css("left", (maxVal(e.pageX - x, jQuery(".img-comp-img").width())) + "px")
    }

    //Mouse was pressed
    slider.mousedown(function (e) {
        e.preventDefault();
        jQuery(window).on("mousemove.slideev", this, slidef);
    });

    jQuery(window).mouseup(function (e) {
        e.preventDefault();
        jQuery(window).off("mousemove.slideev");
    });

    //Finger is swiping
    slider.on("touchmove", function (e) {
        e.preventDefault();
        var t = e.touches[0];
        var x = img.offset().left;
        img.parent().width(maxVal(t.pageX - x, jQuery(".img-comp-img").width()));
        slider.css("left", (maxVal(t.pageX - x, jQuery(".img-comp-img").width())) + "px")
    })
});
  
  } catch(e) { console.error(e); }
})();
})();
